<template>
    
    <!-- v-data-table with editable rows -->
  <div>
      <v-form v-model="valid">
      <v-list dense>
        <div v-for="(item, index) in data" :key="index">
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-title>

              <!-- <v-container fluid class="pa-5" v-if="objectType == 'estate'">
                <fields-d-address-field new estate></fields-d-address-field>
              </v-container> -->

              <v-container fluid class="pa-5" v-if="objectType == 'object'">
                <fields-d-text-field label="Beschrijving" v-model="data[index].name"></fields-d-text-field>
              </v-container>

              <v-container fluid class="pa-5" v-if="objectType == 'company'">
                <fields-d-text-field label="Bedrijfsnaam" v-model="data[index].name"></fields-d-text-field>
              </v-container>

              <v-container fluid v-if="objectType == 'person'">
                <v-layout row class="pa-5">
                  <v-flex>
                    <fields-d-text-field label="Voornaam" v-model="data[index].first_name"></fields-d-text-field>
                  </v-flex>
                  <v-flex class="pl-3">
                    <fields-d-text-field label="Achternaam" v-model="data[index].last_name"></fields-d-text-field>
                  </v-flex>
                </v-layout>
              </v-container>

              </v-list-item-title>
              <v-list-item-action>
                <v-btn @click="removeRow(index)" icon small color="error">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-list-item-action>             
            </template>
  
            </v-list-group>
          <v-divider></v-divider>
        </div>


            <v-list-item>
              <v-layout row justify-center>
                <v-icon medium="" color="success" @click="addRow()">mdi-plus-circle-outline</v-icon>
                <v-btn icon color="error" @click="data = []" v-if="data.length > 0">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-layout>
            </v-list-item>
    </v-list>
    </v-form>

    <v-layout justify-center="" style="min-height:78px;">
      <v-expand-transition>
          <v-layout justify-center="">
          <v-flex xs8>
              <v-btn rounded block color="success" v-if="validObject" @click="createObjects()">Aanmaken</v-btn>
              <v-btn rounded block color="success" :disabled="!validObject" v-if="!validObject">Aanmaken</v-btn>


          </v-flex>
          </v-layout>
      </v-expand-transition>
    </v-layout>     

  <v-layout class="pa-5">
    <v-file-input
      v-model="file"
      :color="app.color"
      counter
      accept=".csv"
      label="File input"
      placeholder="Upload CSV"
      prepend-icon="mdi-file-delimited-outline"
      
      :show-size="1000"
      clearable
    >
    </v-file-input>
  </v-layout>
<v-layout justify-center="">
  <v-flex xs8>
    <v-btn rounded block="" :disabled="file.length == 0" v-if="data.length == 0" color="primary" @click="parseFile()"> Parse csv</v-btn>
  </v-flex>
</v-layout>

  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "../../plugins/axios.js";
import Papa from "papaparse";
import Vue from "vue";
export default {
  props: {
    object: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      item: null,
      headers: [],
      data: [],
      valid: false,
      file: [],
      results: null
    };
  },
  methods: {
    addRow() {
      this.data.push({});
    },
    removeRow(index) {
      this.data.splice(index, 1);
    },
    createObjects() {
      this.$store.dispatch("createMultipleObjects", {
        reference: this.object.reference,
        details: this.data
      });
    },
    parseFile() {
      console.log(this.file);
      Papa.parse(this.file, {
        complete: results => {
          console.log(results);
          var i = 0;
          results.data.forEach(item => {
            if (i == 0) {
              this.headers = item;
            } else {
              var obj = {};
              var a = 0;
              item.forEach(field => {
                obj[this.headers[a]] = field;
                a++;
              });
              this.data.push(obj);
            }
            i++;
          });
        }
      });
    }
  },
  computed: {
    ...mapState(["app"]),

    objectType() {
      if (this.object.is_estate == true) {
        return "estate";
      } else if (this.object.is_company == true) {
        return "company";
      } else if (this.object.is_person == true) {
        return "person";
      } else {
        return "object";
      }
    },
    validObject() {
      if (this.data.length == 0) {
        return false;
      }
      for (var i = 0; i < this.data.length; i++) {
        if (this.objectType != "person") {
          if (this.data[i].name == undefined || this.data[i].name == "") {
            return false;
          }
        } else {
          if (
            this.data[i].first_name == undefined ||
            this.data[i].first_name == "" ||
            this.data[i].last_name == undefined ||
            this.data[i].last_name == ""
          ) {
            return false;
          }
        }
      }
      return true;
    }
  }
};
</script>
